import React, { useEffect, useState } from "react";
import { TopHeaderWrapper, TopText, RegionDropdownNav } from "./topHeader.style";
import { useCheckScreenSize } from "@util/hooks";
import { getAllRegions } from "@api";
import { useStore } from "@util/states";
import { isBrowser, setBaseUrl } from "@util/helper";
import { Link } from "@global";
import { IconDownChevron } from "@util/assets";

interface Props {
  topNote?: string;
}

const TopHeader = ({ topNote }: Props) => {
  const { mediumUp } = useCheckScreenSize();
  const [pathName, setPathName] = useState("");
  const [insanityHeader, setInsanityHeader] = useState(false);

  useEffect(() => {
    if (location.pathname) {
      setPathName(location.pathname);
    }
  }, [isBrowser() && location.pathname]);

  useEffect(() => {
    if (pathName.includes(`brands/x-shot/insanity`)) {
      setInsanityHeader(true);
    } else {
      setInsanityHeader(false);
    }
  }, [pathName]);

  const { currentRegion } = useStore();
  const linkAttr = {
    internalLink: {
      _type: "page",
      slug: {
        current: "voluntary-recall-notice",
      },
      region: {
        iban: currentRegion.iban,
      },
      internal: {
        type: "page",
      },
    },
    linkText: "Learn More",
  };

  const linkClick = (linkAttr: any) => {
    window.location.href = setBaseUrl(linkAttr.internalLink.slug.current, linkAttr.internalLink.region.iban, linkAttr.internalLink._type) as string;
  };

  const productRecallPage = pathName?.includes("voluntary-recall-notice") || pathName?.includes("our-response");

  return (
    <TopHeaderWrapper availableTopNote={topNote ? true : false} insanityHeader={insanityHeader} productRecall={productRecallPage ? true : false}>
  {productRecallPage ? "" : (
    <div className="product-recall-container">
      {/* <Link onClick={() => linkClick(linkAttr)} {...linkAttr} /> */}
      Play Reimagined.
    </div>
  )}
  {topNote && <TopText>{topNote}</TopText>}
  {!topNote ? <TopRegionDropdown /> : mediumUp && <TopRegionDropdown />}
</TopHeaderWrapper>
  );
};
export default TopHeader;

export const TopRegionDropdown = () => {
  const {
    allSanityRegion: { nodes },
  } = getAllRegions();
  const { currentRegion, setCurrentRegion } = useStore();

  const currentRegionData = nodes.filter(node => {
    if (node == null) return;
    if (node.iban === currentRegion.iban) return node;
    if (node.iban === process.env.GATSBY_DEFAULT_IBAN_REGION) return node;
    return null;
  });

  const [statusDropdown, setStatusDropdown] = useState(false);

  const linkClick = (linkAttr: any) => {
    window.location.href = setBaseUrl(linkAttr.internalLink.slug.current, linkAttr.internalLink.region.iban, linkAttr.internalLink._type) as string;
  }

  return (
    <RegionDropdownNav className="region-dropdown" statusDropdown={statusDropdown}>
      <ul>
        <li className="first-dropdown-wrapper">
          {currentRegionData[0] && (
            <button onClick={() => setStatusDropdown(!statusDropdown)}>
              <span>{currentRegionData[0].displayTitle}</span> <IconDownChevron />
            </button>
          )}
          {statusDropdown && (
            <ul onMouseLeave={() => setStatusDropdown(!statusDropdown)}>
              {nodes.map(node => {
                if (node == null) return null;
                const { displayTitle, iban } = node;
                if (iban == null) return null;

                const linkAttr = {
                  internalLink: {
                    _type: "page",
                    slug: {
                      current: "/",
                    },
                    region: {
                      iban: iban,
                    },
                    internal: {
                      type: "page",
                    },
                  },
                  linkText: displayTitle,
                };

                return (
                  <li className="language-list" key={node._id} onClick={() => setCurrentRegion({ iban: iban })}>
                    <Link onClick={() => linkClick(linkAttr)} {...linkAttr} />
                  </li>
                );
              })}
            </ul>
          )}
        </li>
      </ul>
    </RegionDropdownNav>
  );
};
